'use client';

import { CSSProperties, Fragment } from 'react';
import * as S from './styles';
import Plano from '../../molecules/Plano';

import ScrollAreaContainer from '../../molecules/ScrollAreaContainer';
import Heading from '../../atoms/Heading';
import { useHomeData } from '@/hooks/useHomeData';
import useBreakpoint from '@/hooks/useBreakpoint';
import { Skeleton } from '@/components/atoms/Skeleton';
import { registrarEvento } from '@/services/googleAnalytics';

export type PlanosDisponiveisProps = {
  style?: CSSProperties;
};

export default function PlanosDisponiveis(props: PlanosDisponiveisProps) {
  const { breakpoint } = useBreakpoint();

  const { style } = props;
  const { combos } = useHomeData();

  return (
    <S.Container style={style}>
      <S.ContainerTextos $breakpoint={breakpoint}>
        <Heading
          $priority={1}
          $size={6}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text="Planos disponíveis"
        />
      </S.ContainerTextos>
      <ScrollAreaContainer key="planos_listagem" orientacao="horizontal">
        <S.Row $breakpoint={breakpoint}>
          {!combos ? (
            <Fragment>
              <Skeleton style={{ width: 300, height: 160 }} />
              <Skeleton style={{ width: 300, height: 160 }} />
              <Skeleton style={{ width: 300, height: 160 }} />
            </Fragment>
          ) : (
            combos?.map((combo) => (
              <div
                key={combo.comboID}
                onClick={() => registrarEvento('home_clicou_combo', { combo })}
              >
                <Plano key={combo.comboID} {...combo} />
              </div>
            ))
          )}
          {/* <Link key="monte-seu-plano-link" href="/monte-seu-plano">
            <Card
              $size={3}
              $insetContent={true}
              $variant="surface"
              $interactive={false}
            >
              <S.ContainerMontarPlano>
                <S.ContainerMontarPlanoInfo>
                  <Text
                    $size={3}
                    $color="neutral"
                    $weight="bold"
                    $align="center"
                    $highContrast={true}
                    $text="Monte seu plano"
                  />
                  <Text
                    $size={1}
                    $color="neutral"
                    $weight="semibold"
                    $align="center"
                    $highContrast={true}
                    $text="Monte seu plano e ganhe os mesmos benefícios dos planos existentes"
                  />
                  <Button
                    $size={1}
                    $variant="solid"
                    $color="accent"
                    $highContrast={false}
                    $loading={false}
                    $focusRing={false}
                    $text="Montar meu plano"
                    style={{
                      justifyContent: 'center',
                    }}
                  />
                </S.ContainerMontarPlanoInfo>
              </S.ContainerMontarPlano>
            </Card>
          </Link> */}
        </S.Row>
      </ScrollAreaContainer>
    </S.Container>
  );
}
